import { createRouter, createWebHistory } from 'vue-router'
import LohnrechnerView from '@/views/LohnrechnerView.vue'
import LohnLetterView from '@/views/LohnLetterView.vue'
import LohnLetterDetailView from '@/views/LohnLetterDetailView.vue'
import FlatPageView from '@/views/FlatPageView.vue'
import ResultView from '@/views/ResultView.vue'
import FAQView from '@/views/FAQView.vue'
import MappingTestView from '@/views/MappingTestView.vue'
import SurveyResultView from '@/views/SurveyResultView.vue'
import { usePostHog } from '@/composables/usePosthog'

const DOCLANG = document.documentElement.lang

const DE = document.documentElement.lang == 'de-ch'
const FR = document.documentElement.lang == 'fr-ch'
const IT = document.documentElement.lang == 'it-ch'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: LohnrechnerView
    },
    {
      path: '/result',
      name: 'result',
      component: ResultView
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQView
    },
    {
      path: DE ? '/lohnletter' : FR ? '/salaire-info' : '/lohnletter',
      name: 'lohnletter',
      component: LohnLetterView
    },
    {
      path: DE ? '/lohnletter/:slug' : FR ? '/salaire-info/:slug' : '/lohnletter/:slug',
      name: 'lohnletter-detail',
      props: true,
      component: LohnLetterDetailView
    },
    {
      path: '/test-mapping',
      name: 'test-mapping',
      component: MappingTestView
    },
    {
      path: '/pages/:slug',
      name: 'flat-page',
      props: true,
      component: FlatPageView
    },
    {
      path: '/surveys/:uid',
      name: 'survey-result',
      props: true,
      component: SurveyResultView
    },
    {
      path: '/articles/details/154',
      redirect: () => {
        return {
          name: 'flat-page',
          params: {
            slug:
              document.documentElement.lang == 'de-ch'
                ? 'mindestlohne-in-der-schweiz'
                : document.documentElement.lang == 'fr-ch'
                  ? 'les-salaires-minimums-en-suisse'
                  : 'salari-minimi-in-svizzera'
          }
        }
      }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'home' }
    }
  ]
})

const { posthog } = usePostHog()

router.afterEach(() => {
  posthog.capture('$pageview')
})

router.beforeEach((to, from) => {
  if (from.path !== to.path) {
    posthog.capture('$pageleave')
  }
})

export default router
